/**
 * Mirrors the backend range-token grammar
 * (`backend/src/routes/catalogue_rows.rs::parse_range_token`): a
 * search token shaped `<number>-<number>` with optional comma or dot
 * decimals is interpreted server-side as an inclusive numeric range.
 * The editor uses this to skip match-highlighting for range tokens,
 * because there is no literal substring to mark.
 */
const RANGE_TOKEN = /^\d+([.,]\d+)?-\d+([.,]\d+)?$/;

export function isRangeToken(token: string): boolean {
	return RANGE_TOKEN.test(token);
}
